import {Component} from '@angular/core';
import {ModalsService} from "../../services/modals.service";
import {AuthService} from "../../services/auth.service";

@Component({
  selector: 'app-logout-modal',
  templateUrl: './logout-modal.component.html',
  styleUrls: ['./logout-modal.component.css']
})
export class LogoutModalComponent {

  constructor(private readonly modalsService: ModalsService,
              private readonly authService: AuthService) {
  }

  close(): void {
    this.modalsService.hideModal();
  }

  logout(): void {
    this.authService.logout();
    this.close();
  }
}
